import React from 'react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import {getStoredData} from "../../JsonFiles/fetchData";

const AddHiringPage = () => {
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminHiring : {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/hiring'; // API endpoint for creating product
  const successRedirect = '/admin/hiring'; // Redirect after successful product creation

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  );
};


export default AddHiringPage;
